import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, ArrowLeft, Shield, Zap } from 'react-feather';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import BrandWordmark from '../components/BrandWordmark';
import LanguageToggle from '../components/LanguageToggle';
import ThemeToggle from '../components/ThemeToggle';
import Services from './Services';
import './PublicServices.css';

export default function PublicServices() {
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard/services', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="public-services-page">
      {/* Top Header */}
      <header className="public-services-header">
        <div className="public-services-nav-container">
          <Link to="/" className="public-services-brand">
            <BrandWordmark forceLightLogo />
          </Link>

          <div className="public-services-nav-actions">
            <Link to="/" className="public-nav-back-link">
              <ArrowLeft size={16} /> <span>Home</span>
            </Link>
            <LanguageToggle />
            <ThemeToggle />
            <Link to="/login" className="btn btn-secondary public-nav-login-btn">
              {t('nav_login', 'Log In')}
            </Link>
            <Link to="/register" className="btn btn-primary public-nav-signup-btn">
              {t('nav_signup', 'Get Started')} <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </header>

      {/* Public Catalog Banner */}
      <div className="public-services-banner-wrap">
        <div className="public-services-banner-card">
          <div className="public-services-banner-content">
            <div className="public-services-pill">
              <Zap size={14} /> Verified Wholesale Pricing
            </div>
            <h1 className="public-services-title">Services & Pricing Catalog</h1>
            <p className="public-services-subtitle">
              Browse transparent, real-time rates across Instagram, TikTok, YouTube, Telegram, Facebook, and more. 
              Sign up free to fund your wallet with Mobile Money or Crypto and place orders instantly.
            </p>
            <div className="public-services-cta-row">
              <Link to="/register" className="btn btn-primary">
                Create Free Account <ArrowRight size={15} />
              </Link>
              <Link to="/login" className="btn btn-secondary">
                Log In to Order
              </Link>
            </div>
          </div>
          <div className="public-services-perks">
            <div className="public-perk-item">
              <Shield size={18} color="var(--accent)" />
              <span>Zero password required</span>
            </div>
            <div className="public-perk-item">
              <Zap size={18} color="#10b981" />
              <span>Instant API automated delivery</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Services View */}
      <div className="public-services-container">
        <Services />
      </div>
    </div>
  );
}
